module.exports = __webpack_public_path__ + "static/media/Beacon_Icon_Logo.8c801e98.svg";